import React from "react";

import { Page } from "./Page";
import { Content } from "./Content";
import { PageBody } from "./PageBody";
import { PageHeader } from "./PageHeader";
import { Navigation } from "../pages/Navigation";

export const Layout = ({ children }) =>
    <Page>
        <PageHeader />
        <PageBody>
            <Navigation />
            <Content>
                {children}
            </Content>
        </PageBody>
    </Page>;
